import { shallowMount } from "@vue/test-utils";
import LoadingVeridas from "@/views/LoadingVeridas";

describe("LoadingVeridas component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(LoadingVeridas);
  });

  it("Renders del component LoadingVeridas", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
